<div class="tab-pane show active fade details-view-results trial-information" id="trial-information" role="tabpanel">
  <div>
    <div class="trial-information-head">
      <h2>Trial Information</h2>
      <div class="buttons">
        <div class="culture-select">
          <app-input-select #cultureSelect [items]="filteredCultures" [parentForm]="form" controlName="selectedCulture"
                            [allowFiltering]="true" [allowClear]="false" (onFilter)="onCultureFiltered($event)"
                            searchInputPlaceholder="Search..."></app-input-select>
        </div>
        <app-button variant="primary" [isBusy]="form.value.isBusy" text="Save Changes" [disabled]="saveButtonDisabled()" (clicked)="onSubmit()" />
      </div>
    </div>
    <div class="form-container">
      <form [formGroup]="form">
        <app-checkbox formControlName="introductionEnabled" [underline]="true" label="Enable Trial Introduction" note="When enabled, patients will see an introductory message about the trial on their dashboard."></app-checkbox>
      </form>
      <div class="indented-container" [class.visibility-hidden]="!form.value.introductionEnabled">
        @for (cultureForm of cultureForms; track form) {
          <form [formGroup]="cultureForm"
                [class.visibility-hidden]="cultureForm.value.culture !== form.value.selectedCulture">
            <div class="form-group">
              <label for="introductionTitle">
                Introduction Title
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <input type="text" formControlName="introductionTitle" placeholder="Enter the title for the trial introduction...">
            </div>
            <div class="form-group">
              <label for="introductionMessage">
                Introduction Message
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <app-editor formControlName="introductionMessage" placeholder="Write the introductory message patients will see on their dashboard..."></app-editor>
            </div>
          </form>
        }
      </div>
      <form [formGroup]="form">
        <app-checkbox formControlName="trialInformationEnabled" [underline]="true" label="Allow Patients to View Trial Information in App" note="When enabled, patients can access detailed information about the trial within the app."></app-checkbox>
      </form>
      <div class="indented-container" [class.visibility-hidden]="!form.value.trialInformationEnabled">
        @for (cultureForm of cultureForms; track form) {
          <form [formGroup]="cultureForm"
                [class.visibility-hidden]="cultureForm.value.culture !== form.value.selectedCulture">
            <div class="form-group">
              <label for="trialInformation">
                Trial Information
                @if (cultureForm.value.culture === 'en') {
                  <sup>*</sup>
                }
              </label>
              <app-editor formControlName="trialInformation" placeholder="Enter detailed information about the trial for patients to view in the app..."></app-editor>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</div>
